import React, { useRef, useState } from 'react'
import { contact_optons } from '../../data/data'
import './contact.css'
import emailjs from 'emailjs-com'

function Contact() {
  const form = useRef()
  const [loading, setLoading] = useState(false)

  const [message, setMessage] = useState('')

  const showMessage = (msg) => {
    setLoading(false)
    setMessage(msg)
    setTimeout(() => setMessage(''), 2000)
  }
  const sendEmail = (e) => {
    e.preventDefault()
    setLoading(true)
    emailjs
      .sendForm(
        'service_duo3ww3',
        'template_cnudnhi',
        form.current,
        'ew5PJleB-NpXzuCT-'
      )
      .then((res) => {
        e.target.reset()
        showMessage('Message Sent!')
      })
      .catch((err) => {
        console.log(err)
        showMessage(err.message)
      })
  }

  return (
    <section id='contact'>
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact__container'>
        <div className='contact__options'>
          {contact_optons.map(({ icon, title, link, username }, i) => (
            <article key={i + 1} className='contact__option'>
              {icon}
              <h4>{title}</h4>
              <h5>{username}</h5>
              <a target={'_blank'} href={link}>
                Send a Message
              </a>
            </article>
          ))}
        </div>
        <form onSubmit={sendEmail} ref={form}>
          {message && <p className='contact__feedback'>{message}</p>}
          <input
            type='text'
            name='name'
            placeholder='Your Full Name'
            required
          />
          <input type='email' name='email' placeholder='Ypur Email' required />
          <textarea
            name='message'
            id='message'
            placeholder='Your Message'
            required
            rows='7'
          ></textarea>

          <button disabled={loading} type='submit' className='btn btn-primary'>
            {loading ? 'Sending...' : 'Send a Message'}
          </button>
        </form>
      </div>
    </section>
  )
}

export default Contact
